import styled from 'styled-components';

var Wrapper = styled.span.withConfig({
  displayName: "Wrapper",
  componentId: "sc-c1fiv7-0"
})([""]);

export { Wrapper };
